<script lang="ts">
  // Tiny hash-router. URL shapes:
  //   /            → list
  //   /builds/<id> → detail
  // History API is unnecessary for the size of this UI and avoids the SPA
  // refresh trap on a static Cloudflare Pages deploy.

  import BuildsList from "./routes/BuildsList.svelte";
  import BuildDetail from "./routes/BuildDetail.svelte";

  let hash = $state(window.location.hash || "#/");
  $effect(() => {
    const onHash = () => (hash = window.location.hash || "#/");
    window.addEventListener("hashchange", onHash);
    return () => window.removeEventListener("hashchange", onHash);
  });

  const route = $derived.by(() => {
    const m = hash.match(/^#\/builds\/([^/]+)/);
    if (m) return { name: "detail" as const, id: m[1] };
    return { name: "list" as const };
  });
</script>

<header>
  <a href="#/" class="brand">nvr</a>
  <span class="tag">noise visual regression</span>
  <span class="spacer"></span>
  <a class="link" href="https://github.com/noise/noise-tools/blob/main/apps/nvr/README.md" target="_blank" rel="noopener">docs</a>
</header>

<main>
  {#if route.name === "list"}
    <BuildsList />
  {:else if route.name === "detail"}
    <BuildDetail id={route.id} />
  {/if}
</main>

<style>
  :global(html, body) {
    margin: 0;
    background: #0f1218;
    color: #e6e8ee;
    font-family:
      -apple-system, BlinkMacSystemFont, "Segoe UI", Inter, Roboto, sans-serif;
    line-height: 1.5;
  }
  :global(a) {
    color: #7df9c0;
    text-decoration: none;
  }
  :global(a:hover) {
    text-decoration: underline;
  }
  :global(*, *::before, *::after) {
    box-sizing: border-box;
  }
  header {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 24px;
    border-bottom: 1px solid #1c2230;
  }
  .brand {
    font-weight: 600;
    font-size: 20px;
    color: #7df9c0;
  }
  .tag {
    color: #6b7180;
    font-size: 12px;
  }
  .spacer {
    flex: 1;
  }
  .link {
    font-size: 13px;
    color: #9aa1ad;
  }
  main {
    padding: 24px;
    max-width: 1400px;
    margin: 0 auto;
  }
</style>
